<template>
  <!-- 报价详情 -->
  <div class="detail">
    <!-- title -->
    <headers :params="hraderP"></headers>
    <div class="detail-header">
      <p>项目信息</p>
      <p>{{ orderData.newStatus | newStatus }}</p>
    </div>
    <div class="detai-list">
      <div class="detai-list-1">
        <p class="name">{{ orderData.projectName || "--" }}</p>
        <p>
          项目费用: <span class="red">¥{{ orderData.charge }}</span>
        </p>
        <p>
          项目业态:
          <span v-for="item in orderData.buildingType" :key="item.id">{{
            item.name
          }}</span>
          <span v-for="item in orderData.secondBuildingTypeList" :key="item.id"
            >/ {{ item.name }}</span
          >
        </p>
        <p class="list">
          施工系统:
          <span v-for="item in orderData.systemList">{{ item.name }}</span>
        </p>
        <div class="detai-list-2">
          <div class="item">
            <p>项目阶段:</p>
            <p v-if="orderData.projectStage == 1">方案设计</p>
            <p v-if="orderData.projectStage == 2">施工图</p>
            <p v-if="orderData.projectStage == 3">深化设计</p>
            <p v-if="orderData.projectStage == 4">初步设计</p>
          </div>
          <div class="item">
            <p>产品交付:</p>
            <p>{{ orderData.putType | putType }}</p>
            <!-- <p v-if="(orderData.putType).indexOf('1') > -1">方案</p>
            <p v-if="(orderData.putType).indexOf('2') > -1">报价清单</p>
            <p v-if="(orderData.putType).indexOf('3') > -1">图纸</p>
            <p v-if="(orderData.putType).indexOf('4') > -1">标书</p> -->
          </div>
          <div class="item">
            <p>产品时间:</p>
            <p>{{ orderData.deliverDay }}个工作日</p>
          </div>
          <div class="item">
            <p>项目地址:</p>
            <p>
              {{ orderData.provinceName || "--" }}
              <span v-if="orderData.cityName">/{{ orderData.cityName }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="h12"></div>
      <div class="detai-list-3">
        <p class="number" style="margin-bottom: 0;">个人信息</p>
        <div class="detai-list-2" style="border: none;">
          <div class="item">
            <p>联系人:</p>
            <p>{{ orderData.contacts }}</p>
          </div>
          <div class="item">
            <p>联系方式:</p>
            <p>{{ orderData.mobile }}</p>
          </div>
          <div class="item">
            <p>公司名称:</p>
            <p>{{ orderData.companyName }}</p>
          </div>
        </div>
      </div>
      <div class="h12"></div>
      <div class="detai-list-3">
        <p class="number">定制方案合同</p>
        <div class="loadImg">
          <img src="../../assets/images/icon-wenjian.png" />
          <a
            v-if="orderData.newStatus === 20"
            class="order-files-item-title"
            target="_blank"
            @click="goHT(orderData)"
            >河姆渡方案馆弱电智能化设计项目合同</a
          >
          <a
            v-else
            :href="orderData.contractUrl"
            class="order-files-item-title"
            target="_blank"
            >河姆渡方案馆弱电智能化设计项目合同.pdf</a
          >
        </div>
        <div
          class="detai-list-2"
          style="border: none;"
          v-if="orderData.newStatus !== 50"
        >
          <div class="item">
            <p>订单编号:</p>
            <p>{{ orderData.orderNo }}</p>
          </div>
          <div class="item">
            <p>项目费用:</p>
            <p class="red">¥{{ orderData.charge }}</p>
          </div>
        </div>
      </div>

      <!-- 设计中、待验收、已完成 -->
      <!-- <div v-if="orderData.newStatus==2||orderData.newStatus==3||orderData.newStatus==4||orderData.newStatus==5">
        <div class="h12"></div>
        <div class="detai-list-3">
          <p class="number" style="margin-bottom: 0;">设计师</p>
          <div class="detai-list-2" style="border: none;">
           <div class="item">
              <p>设计师姓名:</p>
              <p>{{orderData.realName?orderData.realName:'平台合作设计师'}}</p>
            </div>
            <div class="item">
              <p>派单时间:</p>
              <p>{{orderData.tasks[0].createdTime}}</p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 待验收、已完成 -->
      <div v-if="orderData.newStatus == 4 || orderData.newStatus == 5">
        <div class="h12"></div>
        <div class="detai-list-3">
          <p class="number" style="margin-bottom: 0;">交付成果</p>
          <div class="fileLink">
            <div class="fileLink-left">
              <img src="../../assets/images/file-link.png" />
              <p>附件信息</p>
            </div>
            <div class="fileLink-right">
              点击查看
              <van-icon name="arrow" color="#ccc" />
            </div>
          </div>
          <p style="padding: 8px 0 16px 0;">
            备注：请登录河姆渡 -方案馆网页端查看交付成果
          </p>
        </div>
      </div>

      <template v-if="orderData.newStatus == 20 && orderData.couponAmount">
        <div class="h12"></div>
        <div
          class="detai-list-3"
          style="border: none;padding-bottom: 16px;"
        >
          <div
            style="display: flex;align-items: center;justify-content: space-between;"
          >
            <div style="display: flex;align-items: center;">
              <div style="font-size: 18px;color: #333;font-weight: bold;">
                服务券
              </div>
                已使用<span style="color: #FF0000;">1</span>张
            </div>
            <div style="display: flex;align-items: center;">
              <div>
                优惠<span style="color: #FF0000;">{{orderData.couponAmount}}</span
                >元
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-if="isShowCoupon">
        <div class="h12"></div>
        <div
          class="detai-list-3"
          style="border: none;padding-bottom: 16px;"
          @click="showCoupon = true"
        >
          <div
            style="display: flex;align-items: center;justify-content: space-between;"
          >
            <div style="display: flex;align-items: center;">
              <div style="font-size: 18px;color: #333;font-weight: bold;">
                服务券
              </div>
              <div
                style="margin-left:15px;font-size:14px;counter-reset: #333;"
                v-if="!canUseCouponList.length"
              >
                暂无可用服务券
              </div>
              <div
                style="margin-left:15px;font-size:14px;counter-reset: #333;"
                v-if="checkCounponIdx >= 0"
              >
                已使用<span style="color: #FF0000;">1</span>张
              </div>
            </div>
            <div style="display: flex;align-items: center;">
              <div v-if="checkCounponIdx >= 0">
                优惠<span style="color: #FF0000;">{{
                  canUseCouponList[checkCounponIdx].amount
                }}</span
                >元
              </div>
              <img
                style="width:12px;height: 12px;padding-left: 10px;"
                src="//image01.homedo.com/Files/Images/cms/www/20230825/5673360633117017714_pic1.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </template>

      <div class="zhifu" v-if="orderData.newStatus == 20">
        <button type="button" class="rejust" @click="payList">立即支付</button>
      </div>

      <div class="baojia" v-if="orderData.newStatus == 4">
        <button type="button" class="rejust">联系客服</button>
        <button type="button" class="submit" @click="showPopup">
          确认设计成果
        </button>
      </div>
    </div>
    <div class="coupon-model" v-if="showCoupon">
      <div class="coupon-box">
        <div class="coupon-top">
          <div></div>
          <div>选择服务券</div>
          <img
            style="width: 15px;height: 15px;padding-left: 10px;"
            src="//image01.homedo.com/Files/Images/cms/www/20230825/5166544474203564142_pic1.png"
            @click="showCoupon = false"
          />
        </div>
        <div class="coupon-tips">
          使用服务券，最高可抵扣<span style="color: #FF0000;">{{
            maxMoney
          }}</span
          >元
        </div>
        <div class="coupon-list">
          <div
            class="coupon-item"
            v-for="(item, index) in canUseCouponList"
            @click="changeCoupon(index)"
          >
            <div class="coupon-item-left">
              <div class="coupon-left-top">
                <span>￥</span>
                <div>{{ item.amount }}</div>
              </div>
              <div class="coupon-left-bottom">立减</div>
            </div>
            <div class="coupon-item-right">
              <div class="c-r-top">
                <div class="c-r-t-title">{{ item.amount }}元服务券</div>
                <div class="c-r-t-desc">{{ item.usePlatform }}</div>
                <img
                  v-if="index == checkCounponIdx"
                  class="c-r-check"
                  src="//image01.homedo.com/Files/Images/cms/www/20230825/5526539651149395967_pic1.png"
                  alt=""
                />
                <img
                  v-else
                  class="c-r-check"
                  src="//image01.homedo.com/Files/Images/cms/www/20230825/4868033210287475779_pic1.png"
                  alt=""
                />
              </div>
              <div class="c-r-bottom">
                <div>
                  {{ item.periodOfValidity | timeMount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/headerslf";
import {
  getMycase,
  creatOrderInfo,
  changeStatue
} from "@/api/userPerson/userPerson";
import {
  createOrder,
  getTotalCoin,
  checkDownloadAuth,
  dealAwaitOrder,
  queryCreateOrderNo,
  getOrderInfoByOrderNo,
  couponList
} from "@/api/solutions/solution";
import { newStatus, putType } from "@/filters/status";
import { Row, Col, ImagePreview, Toast } from "vant";
import { Dialog } from "vant";
import { getCookie } from "@/utils/cookies";
export default {
  components: {
    headers
  },
  data() {
    return {
      orderNo: "",
      orderNos: "",
      reqId: "",
      hraderP: {
        title: "订单详情",
        lefticon: true
      },
      orderData: [],
      show: false,
      message: "",
      postData: {
        businessId: 0,
        businessName: "",
        businessType: 3, // 业务类型 1：方案 2：行业规范 3：需求定制 4:品牌管理员申请缴费
        os:
          $HMD$.rNavigator && $HMD$.rNavigator == "msite"
            ? "wap"
            : $HMD$.rNavigator,
        userId: 0,
        orderNo: "",
        couponAmount: 0,
        hebiAmount: 0,
        amount: 0
      },
      queryData: {
        userId: 0,
        businessType: 3,
        businessId: null
      },
      orderId: "",
      showCoupon: false,
      canUseCouponList: [],
      checkCounponIdx: -1,
      maxMoney: 0,
      isShowCoupon: false,   //是否显示
    };
  },
  filters: {
    newStatus,
    putType,
    scope(val) {
      switch (val) {
        case 0:
          return "全平台使用";
          break;
        case 1:
          return "方案定制服务";
          break;
        case 2:
          return "众包特色服务";
          break;
        case 4:
          return "部分众包特色服务";
          break;
        default:
      }
    },
    timeMount(str) {
      if (str) {
        let list = str.split("~");
        return `${list[0].substring(0, 11)} ~ ${list[1] &&
          list[1].substring(0, 11)} `;
      }
      return null;
    }
  },
  created() {
    this.reqId = this.$route.query.reqId;
    this.orderNos = this.$route.query.orderNo;
    (this.postData.userId = getCookie("accountId") || getCookie("AccountId")),
      (this.queryData.userId =
        getCookie("accountId") || getCookie("AccountId")),
      this.getMycaseDetal();
    this.getCreateOrderNo();
  },
  methods: {
    async initpay() {
      this.queryData.businessId = this.orderNos;
      this.queryData._time = new Date().getTime();
      let orderStatus = await checkDownloadAuth(this.queryData);
      if (orderStatus.data.data && !orderStatus.data.data.hasPayOrder) {
        this.getCouponList(this.orderData.charge);
      }
      if (orderStatus.data.data && orderStatus.data.data.orderNo == 0) {
        this.getCouponList(this.orderData.charge);
      }
    },
    async getCouponList(amount) {
      const res = await couponList({
        couponType: 2,
        amount: amount,
        accountId: getCookie("accountId") || getCookie("AccountId")
      });
      this.isShowCoupon = true;
      this.canUseCouponList = (res && res.data && res.data.data) || [];
      let maxIdx = -1;
      let maxMoney = 0;
      this.canUseCouponList.forEach((item, index) => {
        if (item.amount > maxMoney) {
          maxIdx = index;
          maxMoney = item.amount;
        }
      });
      this.checkCounponIdx = maxIdx;
      this.maxMoney = maxMoney;
    },
    changeCoupon(idx) {
      this.checkCounponIdx = this.checkCounponIdx === idx ? -1 : idx;
      this.showCoupon = false;
    },
    // 确认设计成果
    showPopup() {
      Dialog.confirm({
        title: "标题",
        message: "确认设计成果吗？"
      }).then(() => {
        let obj = {
          taskId: this.orderData.tasks[0].id,
          status: 5 //任务状态 1-待接单；2-设计中；3-待审核；4-待验收；5-已完成；6-已拒绝 7-待评价
        };
        changeStatue(obj).then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$toast.success("确认成功");
            setTimeout(() => {
              this.$router.push("/userPerson/userPerson.html");
            }, 300);
          }
        });
      });
    },
    // 获取平台唯一销售订单编号orderNo
    getCreateOrderNo() {
      queryCreateOrderNo().then(res => {
        if (res.status !== 200) {
          return;
        }
        if (res.data.respCode !== "0000") {
          return;
        }
        this.orderNo = res.data.respDesc;
      });
    },
    // 立即支付
    async payList() {
      this.toast = Toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0
      });
      this.queryData.businessId = this.orderNos;
      let orderStatus = await checkDownloadAuth(this.queryData);
      console.log(orderStatus, "111111111111");
      if (orderStatus.data.data && !orderStatus.data.data.hasPayOrder) {
        // 无订单
        this.createNewOrder();
      } else {
        // 有订单
        this.toast.clear();
        if (orderStatus.data.data) {
          var orStatus = orderStatus.data.data.status;
          var payStatus = orderStatus.data.data.payStatus;
          if (orderStatus.data.data.orderNo == 0) {
            this.createNewOrder();
          } else {
            switch (orStatus) {
              case 20:
                // 支付待审核
                if (payStatus) {
                  if (payStatus == 2) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo);
                  }
                  if (payStatus == 3) {
                    Toast("当前订单审核中，请稍等！");
                  }
                  if (payStatus == 1) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo);
                  }
                } else {
                  this.doAwaitOrder(orderStatus.data.data.orderNo);
                }
                break;
              case 30:
                // 跳转下载页面
                this.$router.push(
                  `/downloadFree/${this.detail.solutionId}.html`
                );
                break;
              case 40:
                this.doAwaitOrder(orderStatus.data.data.orderNo);
                break;
              case 50:
                // 已取消订单不具备下载权限，重新创建订单。
                this.createNewOrder();
                break;
              case 60:
                this.doAwaitOrder(orderStatus.data.data.orderNo);
                break;
              case 70:
                this.doAwaitOrder(orderStatus.data.data.orderNo);
                break;
            }
          }
        }
      }
    },
    async doAwaitOrder(orderNo) {
      if ($HMD$.rNavigator !== "msite" && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId();
      }
      this.postData = {
        userId: getCookie("accountId") || getCookie("AccountId"),
        businessName:
          this.orderData.projectName || this.orderData.buildingType[0].name,
        businessType: 3,
        os:
          $HMD$.rNavigator && $HMD$.rNavigator == "msite"
            ? "wap"
            : $HMD$.rNavigator,
        orderNo: orderNo,
        businessId: this.orderNos,
        couponAmount: 0,
        hebiAmount: 0,
        amount: this.orderData.charge
      };
      dealAwaitOrder(orderNo, this.postData).then(res => {
        if (res.status === 200 && res.data.respCode === "0000") {
          // eslint-disable-next-line no-undef
          if ($HMD$.rNavigator.toLowerCase() === "ios") {
            this.getOrderIdToIos(orderNo, res.data.data.url);
          } else {
            window.location.href = res.data.data.url;
          }
        } else {
          Toast("抱歉，无法支付!");
        }
      });
    },
    getOrderIdToIos(orderNo, jumpUrl) {
      getOrderInfoByOrderNo(orderNo).then(res => {
        if (res.data.code !== 1000 && res.data.msg === "处理成功") {
          // eslint-disable-next-line no-undef
          $HMD$.M.sendApp({
            name: "FangAnGuanOrderId",
            orderId: res.data.code && res.data.code.toString()
          });
        }
        window.location.href = jumpUrl;
      });
    },
    // 创建平台订单信息
    createNewOrder() {
      let couponObj = {
        couponAmount: 0,
        couponTablePrimaryId: ''
      }
      if(this.checkCounponIdx >=0) {
        couponObj.couponAmount =    (this.canUseCouponList && this.canUseCouponList[this.checkCounponIdx].amount) || 0;
        couponObj.couponTablePrimaryId =    (this.canUseCouponList && this.canUseCouponList[this.checkCounponIdx].couponId) || '';
      }
      this.postData = {
        userId: getCookie("accountId") || getCookie("AccountId"),
        businessName:
          this.orderData.projectName || this.orderData.buildingType[0].name,
        businessType: 3,
        os:
          $HMD$.rNavigator && $HMD$.rNavigator == "msite"
            ? "wap"
            : $HMD$.rNavigator,
        orderNo: this.orderNo,
        businessId: this.orderNos,
        hebiAmount: 0,
        amount: this.orderData.charge,
        ...couponObj
      };
      creatOrderInfo(this.postData).then(res => {
        console.log(res, "resresres");
        if (res.data.respCode === "0000" && res.status === 200) {
          this.queryOrderInfoByOrderNo();
        } else {
          this.toast.clear();
        }
      });
    },
    getAppAccountId() {
      return new Promise((resolve, reject) => {
        $HMD$.GetLogin(function(data) {
          resolve((data && data.AccountId) || "");
        });
      });
    },
    // 轮询接口,前端调用的查缓存接口
    async queryOrderInfoByOrderNo() {
      if ($HMD$.rNavigator !== "msite" && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId();
      }
      let t = setInterval(() => {
        getOrderInfoByOrderNo(this.orderNo).then(res => {
          if (res.data.code !== 1000 && res.data.msg === "处理成功") {
            clearInterval(t);
            this.orderId = res.data.code;
            this.createNewOrderLast();
          }
        });
      }, 1000);
    },
    // 创建订单,页面跳转
    async createNewOrderLast() {
      this.postData.orderNo = this.orderId;
      if ($HMD$.rNavigator !== "msite" && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId();
      }
      createOrder(this.postData).then(count => {
        this.toast.clear();
        // if (
        //   count.status === 200 &&
        //   count.data &&
        //   count.data.respCode === "0000"
        // ) {
        //   if (this.detailPageUrl.split(".html")[1].indexOf("?") > 0) {
        //     window.location.href = `${this.detailPageUrl}&code=0`;
        //   } else {
        //     window.location.href = `${this.detailPageUrl}?code=0`;
        //   }
        //   return;
        // }
        if (count.status !== 200) {
          Toast("请检查网络");
          return;
        }
        if (
          count.status === 200 &&
          count.data &&
          count.data.respCode !== "0000"
        ) {
          Toast(count.data.respDesc);
          return;
        }
        if (
          count.status === 200 &&
          count.data &&
          count.data.respCode === "0000" &&
          count.data.data &&
          count.data.data.url
        ) {
          // eslint-disable-next-line no-undef
          if ($HMD$.rNavigator.toLowerCase() === "ios") {
            // eslint-disable-next-line no-undef
            $HMD$.M.sendApp({
              name: "FangAnGuanOrderId",
              orderId: this.orderId && this.orderId.toString()
            });
          }
          window.location.href = count.data.data.url;
        }
      });
    },

    getMycaseDetal() {
      getMycase(this.orderNos).then(res => {
        if (res.data.respCode === "0000") {
          this.orderData = res.data.data;
          this.initpay();
        }
      });
    },
    goHT() {
      if ($HMD$.rApi["ENV"] == "fat") {
        window.open(
          "https://solution.fat.homedo.com/users/contract.html?id=".concat(
            this.reqId
          )
        );
      } else {
        window.open(
          "https://solution.homedo.com/users/contract.html?id=".concat(
            this.reqId
          )
        );
      }
    },
    cancle() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss">
.detail {
  .van-popup {
    border-radius: 8px;
  }
  .van-cell {
    background: #f7f8fa;
    margin-left: 5px;
    width: 80%;
  }
}
</style>
<style lang="scss" scoped>
.detail {
  background: #f6f6f6;
  .detail-header {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    color: #fff;
    background-image: url(../../assets/images/back.png);
  }
  .detai-list {
    margin-top: -5px;
    .h12 {
      height: 12px;
    }
    .detai-list-1 {
      padding: 16px 16px 0 16px;
      background: #ffffff;
      border-radius: 10px 10px 0px 0px;
      p {
        margin-bottom: 16px;
      }
      .name {
        font-size: 15px;
        font-weight: bold;
        color: #222222;
        overflow: hidden;
        text-overflow: ellipsis;
        display: box;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .blue {
        color: #2f7bff;
      }
      .red {
        color: #ff0000;
      }
      .list {
        span {
          display: inline-block;
          padding: 3px 6px;
          background: #edf4fe;
          border-radius: 2px;
          border: 1px solid #9dc1ff;
          color: #2f7bff;
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
  .detai-list-2 {
    border-top: 1px dashed #ccc;
    padding-top: 20px;
    p {
      margin-bottom: 14px;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .red {
      color: #ff0000;
    }
  }
  .detai-list-3 {
    padding: 16px 16px 0 16px;
    background: #fff;
    .remark {
      padding-bottom: 10px;
    }
    .number {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 20px;
    }
    .loadImg {
      display: flex;
      align-items: center;
      .order-files-item-title {
        color: rgb(47, 123, 255);
        text-decoration: underline;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }

      p {
        color: #2e7bff;
        text-decoration: underline;
      }
    }
  }
  .zhifu {
    padding-top: 39px;
    button {
      width: 100%;
      height: 44px;
      border-radius: 4px;
      font-weight: 600;
      background: #2f7bff;
      color: #fff;
      border: none;
    }
  }
  .baojia {
    padding: 39px 16px 10px 16px;
    display: flex;
    justify-content: center;
    button {
      width: 167px;
      height: 44px;
      border-radius: 4px;
      font-weight: 600;
    }
    .rejust {
      background: #ecf2ff;
      border: 1px solid #2f7bff;
      color: #2f7bff;
      margin-right: 10px;
    }
    .submit {
      background: #2f7bff;
      border: 1px solid #2f7bff;
      color: #fff;
    }
  }
}
.dialog {
  width: 290px;
  height: 349px;
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 20px;
  .name {
    font-size: 20px;
    text-align: center;
    font-weight: 600;
    color: #333333;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
  }
  .blue {
    font-size: 12px;
    color: #2f7bff;
  }
  .dialog-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .item-label {
      width: 60px;
      text-align: right;
      font-size: 15px;
      color: #222;
    }
    input {
      width: 160px;
      height: 28px;
      background: #f7f8fa;
      border-radius: 2px;
      border: none;
      margin-left: 5px;
      margin-right: 8px;
      padding-left: 10px;
    }
  }
  .button {
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
    button {
      width: 114px;
      height: 35px;
      border-radius: 8px;
      border: none;
      color: #fff;
    }
    .cancle {
      background: #ffffff rgba(47, 123, 255, 0.1);
      color: #2f7bff;
    }
    .comfirm {
      background: #2f7bff;
    }
  }
}
.fileLink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 313px;
  height: 44px;
  background: #f4f6f9;
  padding: 0 12px;
  margin-top: 20px;
  border-radius: 4px;
  .fileLink-left {
    display: flex;
    align-items: center;
    img {
      padding-right: 8px;
    }
  }
  .fileLink-right {
    color: rgba(0, 0, 0, 0.45);
  }
}

.coupon-model {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  .coupon-box {
    width: 100%;
    height: 542px;
    background: #f6f6f6;
    border-radius: 16px 16px 0 0;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px 12px 0;
    box-sizing: border-box;
    .coupon-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #222;
      font-size: 16px;
      font-weight: bold;
    }
    .coupon-tips {
      margin: 22px 0;
      font-size: 12px;
    }
    .coupon-list {
      height: 430px;
      overflow: auto;
    }
    .coupon-item {
      width: 351px;
      height: 90px;
      background: url(//image01.homedo.com/Files/Images/cms/www/20230825/5408228645394254557_pic1.png)
        no-repeat 0 0;
      background-size: 100% 100%;
      display: flex;
      margin-bottom: 10px;
      .coupon-item-left {
        width: 100px;
        flex-shrink: 0;
        .coupon-left-top {
          display: flex;
          padding-top: 14px;
          text-align: center;
          width: 100px;
          font-size: 32px;
          color: #fff;
          font-weight: bold;
          align-items: flex-end;
          justify-content: center;
          span {
            font-size: 12px;
            margin-bottom: 7px;
            margin-right: 2px;
          }
        }
        .coupon-left-bottom {
          margin-left: 38px;
          font-size: 12px;
          color: #fff;
          margin-top: 15px;
        }
      }
      .coupon-item-right {
        flex: 1;
        .c-r-top {
          height: 61px;
          border-bottom: 1px solid #eee;
          padding-left: 12px;
          box-sizing: border-box;
          position: relative;
          .c-r-t-title {
            padding-top: 10px;
            line-height: 20px;
            font-size: 20px;
            color: #222;
            font-weight: bold;
            font-size: 14px;
          }
          .c-r-t-desc {
            height: 15px;
            background: #ffe8eb;
            border-radius: 15px;
            padding: 2px 9px;
            color: #e20000;
            font-size: 10px;
            line-height: 15px;
            display: inline-block;
            margin-top: 5px;
          }
          .c-r-check {
            position: absolute;
            right: 12px;
            bottom: 5px;
            width: 22px;
            height: 22px;
          }
        }
        .c-r-bottom {
          height: 28px;
          padding-left: 12px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #4d4d4d;
          font-size: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/userPerson/mycaseDetail.vue